/* eslint-disable sort-keys */
import React, { Fragment, useEffect, useState } from 'react'
import { object, string, func } from 'prop-types'
import styled from 'styled-components'
import ValidacaoFluxosPagamento from '../components/ValidacaoFluxosPagamento'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import EscolhaEntrega from './EscolhaEntrega'
import EnderecoForm from '../../../components/EnderecoForm/EnderecoForm'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { useEndereco } from '../../../contexts/EnderecoContext'
import {
  DESCRICAO_TELA_ENTREGA,
  TITULO_TELA_ENTREGA,
  ETAPA_PLANO
} from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../utils/helpers/helpersAssinatura'
import { envioUnicoRenovacao, envioUnicoUpgrade } from '../../../api/endereco.servico'
const WrapperNovoEndereco = styled.div`
  max-width: 450px;
  width: 100%;
`

const TelaEntrega = ( {
  etapaAtual,
  location,
  planoExterno,
  primeiraEtapa,
  jumpToPagamento
} ) => {
  const {
    dadosEtapas,
    setarDadosEtapas,
    temaFluxo,
    fluxoPagamentoAtual,
  } = useFluxosPagamento()
  const {
    enderecosCadastrados,
    enderecoVigente,
    getEnderecos,
    postEndereco
  } = useEndereco()

  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ cadastroNovoEndereco, setCadastroNovoEndereco ] = useState()
  const [ postEnderecoSucesso, setPostEnderecoSucesso ] = useState( false )
  const [ hasEnderecoNovoCadastrado, setHasEnderecoNovoCadastrado ] = useState()
  const [ loadingPagamento, setLoadingPagamento ] = useState( false )

  useEffect( () => {
    if ( idAssinatura ) {
      getEnderecos( idAssinatura )
    }
  }, [ idAssinatura ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade(
        dadosGlobaisAssociado.assinaturas,
        modalidadeURL
      )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( !isEmptyObject( cadastroNovoEndereco ) && !isEmptyObject( etapaAtual ) ) {
      setarDadosEtapas( cadastroNovoEndereco, etapaAtual.identificador )
    }
  }, [ cadastroNovoEndereco, etapaAtual ] )

  useEffect( () => {
    if (
      !isEmptyObject( dadosEtapas ) &&
      !isEmptyObject( dadosEtapas[ etapaAtual.identificador ] )
    ) {
      setHasEnderecoNovoCadastrado( dadosEtapas[ etapaAtual.identificador ] )
    }
  }, [ dadosEtapas ] )

  function verifyIfIsRenovacaoOrSegundaAssinatura() {
    if ( fluxoPagamentoAtual === 'CRIACAO_ASSINATURA' ) {
      if ( dadosEtapas[ ETAPA_PLANO ].tipo === 'Anual' ) {
        return true
      } else {
        return false
      }
    }
    if ( fluxoPagamentoAtual === 'RENOVACAO_PLANO' ) {
      return true
    }
    return false
  }

  async function verifyIfHasDisccount( associadoId, assinaturaId, cep, plano ) {
    const formatedPlano = plano === 'Anual' ? 'A' : 'M'

    if ( fluxoPagamentoAtual === 'CRIACAO_ASSINATURA' ) {
      const data = await envioUnicoUpgrade( associadoId, cep, formatedPlano )
      return data
    } else {
      const data = await envioUnicoRenovacao(
        associadoId,
        assinaturaId,
        cep,
        formatedPlano
      )
      return data
    }
  }
  const salvarNovoEndereco = async() => {
    if ( cadastroNovoEndereco ) {
      const dadosEntrega = dadosEtapas[ etapaAtual.identificador ]

      const response = await postEndereco( cadastroNovoEndereco, idAssinatura )
      setPostEnderecoSucesso( Boolean( response ) )
      if ( response ) {
        const dadosNovoEndereco = dadosEtapas[ etapaAtual.identificador ]
        if ( verifyIfIsRenovacaoOrSegundaAssinatura() ) {
          const responseEnvioUnico = await verifyIfHasDisccount(
            dadosGlobaisAssociado.associado.id,
            idAssinatura,
            dadosEntrega.cep,
            dadosEtapas[ ETAPA_PLANO ].tipo
          )

          setarDadosEtapas(
            {
              ...dadosNovoEndereco,
              'id': response.id,
              'hasEnvioUnico': responseEnvioUnico.data.isCompensacao,
              'newEndereco': true
            },
            etapaAtual.identificador
          )
        } else {
          setarDadosEtapas(
            {
              ...dadosNovoEndereco,
              'id': response.id,
              'hasEnvioUnico': false,
              'newEndereco': true
            },
            etapaAtual.identificador
          )
        }
        return true
      } else {
        return false
      }
    }
  }

  const hasSameAddress = async() => {
    let dadosEntrega = dadosEtapas[ etapaAtual.identificador ]
    try {
      if ( etapaAtual.jump ) {
        setLoadingPagamento( true )
      }
      if ( verifyIfIsRenovacaoOrSegundaAssinatura() ) {
        const response = await verifyIfHasDisccount(
          dadosGlobaisAssociado.associado.id,
          idAssinatura,
          dadosEntrega.cep,
          dadosEtapas[ ETAPA_PLANO ].tipo
        )
        dadosEntrega = {
          ...dadosEntrega,
          'hasEnvioUnico': response.data.isCompensacao
        }
        setarDadosEtapas( dadosEntrega, etapaAtual.identificador )
      } else {
        dadosEntrega = {
          ...dadosEntrega,
          'hasEnvioUnico': false
        }
        setarDadosEtapas( dadosEntrega, etapaAtual.identificador )
      }
      if ( etapaAtual.jump ) {
        setLoadingPagamento( false )
        jumpToPagamento()
      }
      return true
    } catch ( ex ) {
      dadosEntrega = {
        ...dadosEntrega,
        'hasEnvioUnico': false
      }
      setarDadosEtapas( dadosEntrega, etapaAtual.identificador )
      return false
    }
  }

  useEffect( () => {
    if ( etapaAtual.jump && dadosEtapas[ etapaAtual.identificador ] ) {
      hasSameAddress()
    }
  }, [ dadosEtapas[ etapaAtual.identificador ] ] )

  if ( loadingPagamento ) {
    return (
      <InlineLoader
        cor={ temaFluxo }
        isCenter
      />
    )
  }

  return (
    <ValidacaoFluxosPagamento
      acaoAdicionalBotaoProximo={
        cadastroNovoEndereco ? salvarNovoEndereco : hasSameAddress
      }
      etapaAtual={ etapaAtual }
      location={ location }
      planoExterno={ planoExterno }
      primeiraEtapa={ primeiraEtapa }
      sucessoAcao={ postEnderecoSucesso }
    >
      {!loadingPagamento ? (
        <Fragment>
          <h3>{TITULO_TELA_ENTREGA}</h3>

          <p>{DESCRICAO_TELA_ENTREGA}</p>

          {!isEmptyObject( enderecoVigente ) ? (
            <EscolhaEntrega
              enderecoVigente={ enderecoVigente }
              enderecos={ enderecosCadastrados }
              etapaAtual={ etapaAtual }
              setarNovoEndereco={ setCadastroNovoEndereco }
            />
          ) : (
            <WrapperNovoEndereco>
              <EnderecoForm
                endereco={
                  !isEmptyObject( hasEnderecoNovoCadastrado ) &&
                  hasEnderecoNovoCadastrado
                }
                onConfirmar={ enderecoRetornado => setCadastroNovoEndereco( enderecoRetornado ) }
              />
            </WrapperNovoEndereco>
          )}
        </Fragment>
      ) : (
        <InlineLoader
          cor={ temaFluxo }
          isCenter
        />
      )}
    </ValidacaoFluxosPagamento>
  )
}

TelaEntrega.defaultProps = {
  'modalidadeFluxo': null,
  'planoExterno': null
}

TelaEntrega.propTypes = {
  'etapaAtual': object.isRequired,
  'location': object.isRequired,
  'modalidadeFluxo': string,
  'planoExterno': object,
  'primeiraEtapa': string.isRequired,
  'jumpToPagamento': func.isRequired,
}

export default TelaEntrega
